import React from 'react'
// libs
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'
// components
import Grid from '@mui/material/Grid2'
import { ReduxSelect } from 'components/FormElements/ReduxForm'
// hooks
import { useShowModal } from 'hooks/index'
// constants
import { INPUT_METHOD_VALUES, Modals } from 'constants/index'
// static
import APIIconOrigin from 'src/icons/api.svg'
// types
import { IOption } from 'components/FormElements/Select'
import { IFieldOption } from 'types/graphql'
// utils
import find from 'lodash/fp/find'
import get from 'lodash/get'
import pipe from 'lodash/fp/pipe'
import { safeGetOr } from 'utils/fp'
import { size } from 'polished'

// styled
const APIIcon = styled(APIIconOrigin)<any>`
  && {
    margin-left: 10px;
    cursor: pointer;
    ${size('36px')};
  }
`

// types
interface IIncomingProps {
  canModify: boolean
  fieldOptions: IFieldOption[]
  form: string
  label: string
  options: IFieldOption[]
}

const InputMethod: React.FC<IIncomingProps> = ({ canModify, fieldOptions, form, label, options }) => {
  const { showModal } = useShowModal({ modalType: Modals.KPI_INTEGRATION_MODAL })

  const { inputMethod } = useSelector((state) => ({
    inputMethod: formValueSelector(form)(state, 'inputMethod')
  }))

  const isIntegration = pipe(
    find((option: IFieldOption) => option.id === get(inputMethod, 'value')),
    safeGetOr<any, any, any>('', 'value'),
    (inputMethod) => inputMethod === INPUT_METHOD_VALUES.INTEGRATION
  )(fieldOptions)

  const showIntegrationModal = () => showModal()

  const inputMethodOptions = options.filter((option) => option.label)

  return (
    <Grid container direction={'row'} alignItems={'flex-end'}>
      <Grid style={{ flex: 1 }}>
        <ReduxSelect
          isDisabled={!canModify}
          label={label}
          name={'inputMethod'}
          options={inputMethodOptions as IOption[]}
        />
      </Grid>
      {isIntegration && <APIIcon onClick={showIntegrationModal} />}
    </Grid>
  )
}

export default InputMethod
